import { render } from "./SearchComponent.vue?vue&type=template&id=11a52a40&scoped=true"
import script from "./SearchComponent.vue?vue&type=script&lang=js"
export * from "./SearchComponent.vue?vue&type=script&lang=js"

import "./SearchComponent.vue?vue&type=style&index=0&id=11a52a40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a52a40"]])

export default __exports__